export const animation = {
  deleteAnimation: "Delete Animation",
  deleteConfirm: "Are you sure you want to delete this animation? This action cannot be undone.",
  toggleActiveTitle: "Change Animation Status",
  toggleActiveToActive: "Are you sure you want to make this animation active?",
  toggleActiveToInactive: "Are you sure you want to make this animation inactive?",
  status: "Status",
  pending: "Pending",
  started: "Started",
  expired: "Expired",
  active: "Active",
  inactive: "Inactive",
  appBarTitle: "Animations",
  title: "Animations",
  addAnimation: "Create",
  editAnimation: "Edit",
  uploadFile: "Upload Animation File",
  uploadFileEn: "Animation File English",
  uploadFileAr: "Animation File Arabic",
  name: "Animation File Name",
  startDate: "Start Date",
  endDate: "End Date",
  fileSize: "File size",
  backgroundColor: "Background Color",
  validation: {
    endDateAfterStartDate: "Start date must be earlier than end date",
    fileIsRequired: "JSON File is required",
    animationFileNameRequired: "Animation file name is required",
    backgroundColorRequired: "Background color is required",
    backgroundColorInvalid: "Please enter a valid hex color (e.g. #AABBCC)",
    startDateRequired:"Start date is required",
    endDateRequired:"End date is required",
    startDateInvalid:"Start date is invalid",
    endDateInvalid:"End date is invalid",
  },
  success: {
    saved: "Animation saved successfully"
  },
  error: {
    saveFailed: "Failed to save animation"
  },
  animationDetails: {
    animationDetails: "Animation Details",
    englishAnimationFile: "English Animation File",
    arabicAnimationFile: "Arabic Animation File",
    status: {
      started: "Started",
      expired: "Expired",
      pending: "Pending",
      active: "Active",
      inactive: "Inactive",
    },
    animationName: "Animation Name",
    backgroundColor: "Background Color",
    startDate: "Start Date",
    endDate: "End Date",
  },
};
